<template>
  <div class="Site PageBox">
    <van-nav-bar
      fixed
      :border="false"
      :title="$t('language')"
      left-arrow
      @click-left="$router.go(-1)"
      style="color:#fff"
    />
    <div class="ScrollBox">
		<van-cell :icon="`./static/icon/yd-YD.png`" title="தமிழ்" is-link @click="changeLanguage('tm')" v-if="InitData.setting.tm==1"  />
		<van-cell :icon="`./static/icon/yd-YD.png`" title="తెలుగు" is-link @click="changeLanguage('te')" v-if="InitData.setting.te==1"  />
		<van-cell :icon="`./static/icon/yd-YD.png`" title="हिंदी" is-link @click="changeLanguage('yd')" v-if="InitData.setting.yd==1"  />
      <van-cell :icon="`./static/icon/srb.png`" title="Србијa" is-link @click="changeLanguage('srb')" v-if="InitData.setting.srb==1"  />
		  <van-cell :icon="`./static/icon/s.png`" title="عربي" is-link @click="changeLanguage('st')" v-if="InitData.setting.st==1"  />
      <van-cell :icon="`./static/icon/ru.svg`" title="Русский" is-link @click="changeLanguage('ru')" v-if="InitData.setting.ru==1"  />
      <van-cell :icon="`./static/icon/by.svg`" title="беларускі" is-link @click="changeLanguage('by')" v-if="InitData.setting.by==1"  />
      <van-cell :icon="`./static/icon/kaz.svg`" title="қазақ" is-link @click="changeLanguage('kaz')" v-if="InitData.setting.kaz==1"  />
      <van-cell :icon="`./static/icon/tjk.png`" title="тоҷикӣ" is-link @click="changeLanguage('tjk')" v-if="InitData.setting.tjk==1"  />
      <van-cell :icon="`./static/icon/en-US.png`" title="English" is-link @click="changeLanguage('en-US')" v-if="InitData.setting.en==1" />
      <van-cell :icon="`./static/icon/zh-CN.png`" title="简体中文" is-link @click="changeLanguage('zh-CN')" v-if="InitData.setting.cn==1" />

	</div>
  </div>
</template>
<script>
export default {
  name: 'Language',
  components: {

  },
  props: {},
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    
  },
  mounted() {
    
  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    changeLanguage(lan) {
      this.$SetLanguage(lan)
      this.$Model.GetBackData()
      this.$router.go(-1)
    },
  }
}
</script>
<style lang="scss" scoped>
.van-cell__left-icon{
  height: auto;
  line-height: 1;
}
/deep/ .van-nav-bar__title{color:#fff}
</style>